import React, { useState } from 'react';
import Styled from 'styled';
import range from 'lodash/range';
import { FormattedMessage } from 'react-intl';
import { ApolloQueryResult } from '@apollo/client';

import SVGIcon from 'lib/images/svg-icon/svg-icon';

import dot from 'four-nets/icons/svg/icon_dot.svg';

import defaultStyles from './settings-account.scss';
import EmailDialog from './email-dialog/email-dialog';
import PasswordDialog from './password-dialog/password-dialog';
import { SettingsUserAccountFragment } from './settings-user-account.graphql';
import {
    SettingsProfileAndAccountQuery,
    SettingsProfileAndAccountQueryVariables,
} from '../settings-profile-and-account.graphql';

interface Props extends SettingsUserAccountFragment {
    styles: typeof defaultStyles;
    refetch: (
        variables?: SettingsProfileAndAccountQueryVariables | undefined
    ) => Promise<ApolloQueryResult<SettingsProfileAndAccountQuery>>;
}

const SettingsAccount: React.FC<Props> = props => {
    const { styles, email, username, hasPendingEmail, id, refetch } = props;

    const [showPasswordDialog, setShowPasswordDialog] = useState(false);
    const [showEmailDialog, setShowEmailDialog] = useState(false);

    return (
        <div className={styles.wrapper}>
            <PasswordDialog
                id={id}
                username={username}
                open={showPasswordDialog}
                onClose={() => setShowPasswordDialog(false)}
            />
            <EmailDialog
                id={id}
                email={email}
                refetch={refetch}
                open={showEmailDialog}
                onClose={() => setShowEmailDialog(false)}
            />
            <FormattedMessage id='LOGIN_DATA'>{msg => <h3 className={styles.header}>{msg}</h3>}</FormattedMessage>
            <div className={styles.usernameWrapper}>
                <span>{username}</span>
                <FormattedMessage id='USERNAME_CAN_NOT_BE_CHANGED'>
                    {msg => <span className={styles.infoText}>{msg}</span>}
                </FormattedMessage>
            </div>
            <div className={styles.passwordWrapper}>
                <div className={styles.passwordTitleAndButton}>
                    <FormattedMessage id='PASSWORD'>{msg => <span>{msg}</span>}</FormattedMessage>
                    <button
                        className={styles.passwordButton}
                        onClick={() => setShowPasswordDialog(!showPasswordDialog)}
                    >
                        <FormattedMessage id='CHANGE_PASSWORD' />
                    </button>
                </div>
                {range(8).map(value => (
                    <SVGIcon style={{ image: styles.svgIconImage }} key={value} src={dot} />
                ))}
            </div>
            <div className={styles.emailWrapper}>
                <div className={styles.emailTitleAndButton}>
                    <FormattedMessage id='CUSTOMER_EMAIL'>{msg => <span>{msg}</span>}</FormattedMessage>
                    <button className={styles.emailButton} onClick={() => setShowEmailDialog(!showEmailDialog)}>
                        <FormattedMessage id='CHANGE_EMAIL' />
                    </button>
                </div>
                <span className={styles.email}>{email}</span>
                {hasPendingEmail ? (
                    <FormattedMessage id='EMAIL_CHANGE_WARNING'>
                        {msg => <span className={styles.emailWarning}>{msg}</span>}
                    </FormattedMessage>
                ) : null}
            </div>
        </div>
    );
};

export default Styled(defaultStyles)(SettingsAccount);
